import { render, staticRenderFns } from "./ColoredDot.vue?vue&type=template&id=9ba59334&scoped=true"
import script from "./ColoredDot.vue?vue&type=script&lang=js"
export * from "./ColoredDot.vue?vue&type=script&lang=js"
import style0 from "./ColoredDot.vue?vue&type=style&index=0&id=9ba59334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba59334",
  null
  
)

export default component.exports